var map = {
	"./symbol_0.png": "8ea7",
	"./symbol_1.png": "9030",
	"./symbol_2.png": "9509",
	"./symbol_3.png": "f917",
	"./symbol_4.png": "d720",
	"./symbol_5.png": "06f8",
	"./symbol_6.png": "34c6",
	"./symbol_7.png": "f34f",
	"./symbol_8.png": "da82"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "36c3d";